"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_router_1 = require("react-router");
const ContentUploadWrapper_1 = __importDefault(require("components/editor/ContentUploadWrapper"));
const injector_1 = require("ContentAdmin/injector");
const Location_1 = require("helpers/Location");
const useShellContext_1 = require("hooks/useShellContext");
const mobx_react_1 = require("mobx-react");
const auth_1 = require("modules/auth");
const contentPortal_1 = __importDefault(require("modules/content/components/contentPortal"));
const useUpdateUploadTemporaryId_1 = require("modules/content/components/useUpdateUploadTemporaryId");
const featureToggle_1 = require("modules/featureToggle");
const MembershipService_1 = __importDefault(require("modules/membership/MembershipService"));
const ComplementaryReading_1 = __importDefault(require("./complementaryReading/ComplementaryReading"));
const DuplicationModal_1 = __importDefault(require("./duplication/DuplicationModal"));
const fileAttachmentSectionWrapper_1 = __importDefault(require("./fileAttachmentSectionWrapper"));
const filePlayerGroupWrapper_1 = __importDefault(require("./filePlayerGroupWrapper"));
const Tags_1 = __importDefault(require("./tags/Tags"));
const useClearLastModuleId_1 = __importDefault(require("./useClearLastModuleId"));
const drippingFormModal_1 = __importDefault(require("../dripping/components/drippingForm/drippingFormModal"));
const drippingListWrapper_1 = __importDefault(require("../dripping/components/drippingListWrapper"));
const contentPortals = [
    { component: ContentUploadWrapper_1.default, name: 'ContentEditor' },
    { component: fileAttachmentSectionWrapper_1.default, name: 'FileAttachmentSection' },
    { component: drippingFormModal_1.default, name: 'DrippingFormModal' },
    { component: filePlayerGroupWrapper_1.default, name: 'FilePlayerGroup' },
    { component: ComplementaryReading_1.default, name: 'ComplementaryReading' },
    { component: Tags_1.default, name: 'Tags' },
    { component: drippingListWrapper_1.default, name: 'DrippingList' },
    { component: DuplicationModal_1.default, name: 'ModuleDuplicationModal' }
];
const mapStateToProps = ({ MembershipStore, ModuleEditorStore, FeatureToggleStore: { featureToggles } }) => ({
    productId: MembershipStore.productId,
    productName: MembershipStore.name,
    currencyCode: MembershipStore.currencyCode,
    isSubscription: MembershipStore.subscription,
    moduleDisplayType: ModuleEditorStore.moduleDisplayType,
    createModuleConceptToggle: featureToggles.get(featureToggle_1.FeatureToggles.CreateModuleConcept),
    createContentConceptToggle: featureToggles.get(featureToggle_1.FeatureToggles.CreateContentConcept),
    bulkActionMenuToggle: featureToggles.get(featureToggle_1.FeatureToggles.BulkActionMenu),
    contentListConceptToggle: featureToggles.get(featureToggle_1.FeatureToggles.ContentListConcept)
});
const ContentMicrofront = ({ productId, productName, currencyCode, isSubscription, moduleDisplayType, createModuleConceptToggle, createContentConceptToggle, bulkActionMenuToggle, contentListConceptToggle }) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const shellContext = (0, useShellContext_1.useShellContext)();
    const history = (0, react_router_1.useHistory)();
    const location = (0, react_router_1.useLocation)();
    const authorities = (_a = shellContext.user) === null || _a === void 0 ? void 0 : _a.authorities;
    const memoizedAuthorities = authorities === null || authorities === void 0 ? void 0 : authorities.join(',');
    (0, useClearLastModuleId_1.default)();
    (0, useUpdateUploadTemporaryId_1.useUpdateUploadTemporaryId)();
    (0, react_1.useEffect)(() => {
        const onContentHistoryChange = (event) => {
            if (!(0, Location_1.locationsAreEqual)(location, event.detail)) {
                history.push(event.detail);
            }
        };
        window.addEventListener('contenthistorychange', onContentHistoryChange);
        return () => {
            window.removeEventListener('contenthistorychange', onContentHistoryChange);
        };
    }, [location, history]);
    (0, react_1.useEffect)(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        injector_1.Injector.inject('content-admin', {
            token: auth_1.AuthService.token,
            language: shellContext.locale,
            membershipSlug: shellContext.slug,
            subdomain: MembershipService_1.default.subdomain,
            membershipId: MembershipService_1.default.membershipId,
            basename: `/${shellContext.basename}/admin/beta`,
            arrivedFrom: (_a = location.state) === null || _a === void 0 ? void 0 : _a.arrivedFrom,
            user: {
                id: (_c = (_b = shellContext.user) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : '',
                name: (_e = (_d = shellContext.user) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : '',
                email: (_g = (_f = shellContext.user) === null || _f === void 0 ? void 0 : _f.email) !== null && _g !== void 0 ? _g : '',
                ucode: (_j = (_h = shellContext.user) === null || _h === void 0 ? void 0 : _h.ucode) !== null && _j !== void 0 ? _j : '',
                sessionId: (_l = (_k = shellContext.user) === null || _k === void 0 ? void 0 : _k.sessionId) !== null && _l !== void 0 ? _l : '',
                authorities: (memoizedAuthorities === null || memoizedAuthorities === void 0 ? void 0 : memoizedAuthorities.split(',')) || [],
                isAttendant: shellContext.isAttendant
            },
            product: {
                id: productId,
                isSubscription,
                moduleDisplayType,
                name: productName,
                defaultCurrency: currencyCode
            },
            navigate: (pathname) => {
                history.push(pathname);
            },
            createContentConceptToggle,
            createModuleConceptToggle,
            contentListConceptToggle,
            bulkActionMenuToggle
        });
        return () => injector_1.Injector.cleanup();
    }, [
        currencyCode,
        history,
        memoizedAuthorities,
        moduleDisplayType,
        productId,
        productName,
        isSubscription,
        shellContext.basename,
        shellContext.locale,
        shellContext.slug,
        (_b = shellContext.user) === null || _b === void 0 ? void 0 : _b.email,
        (_c = shellContext.user) === null || _c === void 0 ? void 0 : _c.id,
        (_d = shellContext.user) === null || _d === void 0 ? void 0 : _d.name,
        (_e = shellContext.user) === null || _e === void 0 ? void 0 : _e.sessionId,
        (_f = shellContext.user) === null || _f === void 0 ? void 0 : _f.ucode,
        shellContext.isAttendant,
        (_g = location.state) === null || _g === void 0 ? void 0 : _g.arrivedFrom,
        createContentConceptToggle,
        createModuleConceptToggle,
        contentListConceptToggle,
        bulkActionMenuToggle
    ]);
    return ((0, jsx_runtime_1.jsx)("div", { id: "content-admin", children: contentPortals.map((c) => ((0, jsx_runtime_1.jsx)(contentPortal_1.default, { name: c.name, component: c.component }, c.name))) }));
};
exports.default = (0, mobx_react_1.inject)(mapStateToProps)(ContentMicrofront);
